import { DialogActions, DialogContent, FormControl, TextField } from "@mui/material";
import DialogHESP from "../DialogHESP/DialogHESP";
import DialogFooterWithLoading from "../Loading/DialogFooterWithLoading";
import { useMutation } from "react-apollo";
import { UpdateDatacenter, UpdateDatacenterVariables } from "./__generated__/UpdateDatacenter";
import { toast } from "react-toastify";
import { useState } from "react";
import HESPFormLabel from "../HESPFormLabel/HESPFormLabel";
import { GET_DATACENTER } from "../../views/App/TLADatacenter";
import { UPDATE_DATACENTER } from "./TLAUpdateDatacenterIdDialog";

interface Props {
    id: string;
    name: string;
    open: boolean;
    onClose: () => void;
}

export default function TLAUpdateDatacenterNameDialog({ id, name: initName, open, onClose }: Props) {
    const [name, setName] = useState<string>(initName);

    const [updateDc, { loading }] = useMutation<UpdateDatacenter, UpdateDatacenterVariables>(UPDATE_DATACENTER);

    async function onUpdateDatacenterName(): Promise<void> {
        try {
            await updateDc({
                variables: {
                    input: {
                        id,
                        name,
                    },
                },
                refetchQueries: [
                    {
                        query: GET_DATACENTER,
                        variables: {
                            id,
                        },
                    },
                ],
            });
            toast.success("Datacenter name updated!");
            onClose();
        } catch {
            toast.error("Something went wrong");
        }
    }

    return (
        <DialogHESP
            title="Update datacenter name"
            onClose={onClose}
            open={open}
            content={
                <>
                    <DialogContent>
                        <FormControl fullWidth>
                            <HESPFormLabel label="New ID" />
                            <TextField
                                placeholder="New ID"
                                fullWidth
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                            />
                        </FormControl>
                    </DialogContent>
                    <DialogActions>
                        <DialogFooterWithLoading
                            onActionClick={onUpdateDatacenterName}
                            isLoading={loading}
                            onCancelClick={onClose}
                            disabled={name.trim().length === 0}
                            defaultText={"Update"}
                            loadingText={"Updating..."}
                        />
                    </DialogActions>
                </>
            }
        />
    );
}
